export default __webpack_public_path__ + "static/media/circle1.57fff12b.png";